import { render, staticRenderFns } from "./ValueList.vue?vue&type=template&id=2136277f&scoped=true"
import script from "./ValueList.vue?vue&type=script&lang=js"
export * from "./ValueList.vue?vue&type=script&lang=js"
import style0 from "./ValueList.vue?vue&type=style&index=0&id=2136277f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136277f",
  null
  
)

export default component.exports